// extracted by mini-css-extract-plugin
module.exports = {"welcomeTop":"_28_PCtXq","approvedContainer":"UGQ6OtrE","approvedMessage":"_29zuBzNW","approvedHeader":"_3QHd8S_W"};
    if(module.hot) {
      // 1754515027472
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  